import { __assign } from "tslib";
import { createChatAutoAssignSettings } from './';
import { createFakeGetResponder, createFakePostResponder, createFakePutResponder } from '../../../test-utils';
import { createHttpTestKit } from '../../../http/test-kit';
export var createChatAutoAssignApiTestkit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createChatAutoAssignSettings('', fakeHttp);
    var testKit = {
        whenGetChatAutoAssignSettings: function () {
            return createFakeGetResponder(fakeHttp, '/chat');
        },
        whenSetChatAutoAssignSettings: function (dto) {
            return createFakePutResponder(fakeHttp, '/chat')(dto);
        },
        whenEnableChatAutoAssign: function () {
            return createFakePostResponder(fakeHttp, '/chat/enable')({});
        },
        whenDisableChatAutoAssign: function () {
            return createFakePostResponder(fakeHttp, '/chat/disable')({});
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map